var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.changeFontelloConfig = void 0;

var _config = _interopRequireDefault(require("./config.json"));

var fontelloConfig = _config.default;

var changeFontelloConfig = function changeFontelloConfig(newConfig) {
  fontelloConfig = newConfig;
};

exports.changeFontelloConfig = changeFontelloConfig;

var _default = function _default(name) {
  var glyph = fontelloConfig.glyphs.find(function (item) {
    return item.css === name;
  });
  return glyph ? glyph.code : null;
};

exports.default = _default;